
import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';

function BackLink({ to, children }) {
  return (
    <Link to={ to } className={ 'w-fit flex items-center space-x-2' }>
      <ArrowLeftIcon className={ 'w-4 h-4' }/> <span className={ 'text-gray-500 text-xs' }>{ children }</span>
    </Link>
  );
}

export default BackLink;